import { render, staticRenderFns } from "./bjs.vue?vue&type=template&id=67e49f28&scoped=true&"
import script from "./bjs.vue?vue&type=script&lang=js&"
export * from "./bjs.vue?vue&type=script&lang=js&"
import style0 from "./bjs.vue?vue&type=style&index=0&id=67e49f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e49f28",
  null
  
)

export default component.exports